/** @flow */
import type { State } from "@store/reducers";
import type { ManagerType } from "@modules/reporting/reducer/manager/types";
import type {
  ManagerDetailsTasks,
  ManagerDetailsLogins,
} from "@modules/reporting/reducer/manager/manager-details/types";
import type { EmployeeType } from "@modules/employee/types";

export const getManagerDetails = (state: State): $PropertyType<ManagerType, "managerDetails"> =>
  state.reporting.manager.managerDetails;

export const getDetails = (state: State): ?EmployeeType => getManagerDetails(state).details;

export const getManagerDetailsLogins = (state: State): ManagerDetailsLogins =>
  getManagerDetails(state).logins;

export const getManagerDetailsTasks = (state: State): ManagerDetailsTasks =>
  getManagerDetails(state).tasks;
